// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"4fe84270","453":"36e54628"}[chunkId] + ".chunk.js";
};